import { render, staticRenderFns } from "./DetailHistorialPacientes.vue?vue&type=template&id=7c101769&scoped=true&"
import script from "./DetailHistorialPacientes.vue?vue&type=script&lang=js&"
export * from "./DetailHistorialPacientes.vue?vue&type=script&lang=js&"
import style0 from "./DetailHistorialPacientes.vue?vue&type=style&index=0&id=7c101769&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c101769",
  null
  
)

export default component.exports